/**
 * Scene configurations for Election Detail scrollytelling backdrop.
 * Each scene maps to a chapter and defines visual elements for the animated backdrop.
 */

export const STORY_SCENES = {
  'what-to-expect': {
    label: 'What to expect',
    color: 'from-blue-50 via-blue-100 to-indigo-100',
    description: 'You have a right to vote. This is straightforward.',
    elements: [
      {
        type: 'circle',
        size: 'w-96 h-96',
        position: 'top-10 -left-20',
        opacity: 'opacity-30',
        color: 'bg-blue-400',
        blur: 'blur-2xl',
      },
      {
        type: 'circle',
        size: 'w-64 h-64',
        position: 'bottom-20 right-0',
        opacity: 'opacity-20',
        color: 'bg-indigo-300',
        blur: 'blur-3xl',
      },
      {
        type: 'checkmark',
        position: 'top-1/3 right-1/4',
        scale: 'scale-50',
        opacity: 'opacity-10',
      },
    ],
  },

  'when-and-how': {
    label: 'When and how you can vote',
    color: 'from-amber-50 via-orange-100 to-amber-100',
    description: 'Multiple ways fit different schedules.',
    elements: [
      {
        type: 'circle',
        size: 'w-80 h-80',
        position: 'top-1/4 left-0',
        opacity: 'opacity-25',
        color: 'bg-amber-400',
        blur: 'blur-3xl',
      },
      {
        type: 'line',
        position: 'absolute bottom-1/3 left-0 right-0',
        opacity: 'opacity-15',
      },
      {
        type: 'circle',
        size: 'w-52 h-52',
        position: 'bottom-10 right-1/3',
        opacity: 'opacity-20',
        color: 'bg-orange-300',
        blur: 'blur-2xl',
      },
    ],
  },

  'be-ready': {
    label: 'What you need to be ready',
    color: 'from-green-50 via-emerald-100 to-teal-100',
    description: 'A quick checklist to feel confident.',
    elements: [
      {
        type: 'circle',
        size: 'w-72 h-72',
        position: 'top-0 right-0',
        opacity: 'opacity-30',
        color: 'bg-emerald-400',
        blur: 'blur-3xl',
      },
      {
        type: 'circle',
        size: 'w-48 h-48',
        position: 'bottom-1/4 left-1/4',
        opacity: 'opacity-20',
        color: 'bg-teal-300',
        blur: 'blur-2xl',
      },
      {
        type: 'checkmark',
        position: 'bottom-1/3 right-10',
        scale: 'scale-75',
        opacity: 'opacity-15',
      },
    ],
  },

  'your-ballot': {
    label: "What's on your ballot",
    color: 'from-purple-50 via-purple-100 to-pink-100',
    description: "Preview what you'll see in the voting booth.",
    elements: [
      {
        type: 'circle',
        size: 'w-80 h-80',
        position: 'top-1/3 -right-10',
        opacity: 'opacity-25',
        color: 'bg-purple-400',
        blur: 'blur-3xl',
      },
      {
        type: 'rect',
        size: 'w-96 h-48',
        position: 'bottom-0 left-1/4',
        opacity: 'opacity-15',
        color: 'bg-pink-300',
        blur: 'blur-2xl',
      },
      {
        type: 'circle',
        size: 'w-40 h-40',
        position: 'top-1/2 left-10',
        opacity: 'opacity-20',
        color: 'bg-purple-300',
        blur: 'blur-3xl',
      },
    ],
  },

  'next-step': {
    label: 'Your next step',
    color: 'from-rose-50 via-red-100 to-orange-100',
    description: "You're ready. One clear action.",
    elements: [
      {
        type: 'circle',
        size: 'w-96 h-96',
        position: 'top-0 left-0',
        opacity: 'opacity-30',
        color: 'bg-rose-400',
        blur: 'blur-2xl',
      },
      {
        type: 'circle',
        size: 'w-60 h-60',
        position: 'bottom-1/3 right-1/4',
        opacity: 'opacity-25',
        color: 'bg-orange-300',
        blur: 'blur-3xl',
      },
      {
        type: 'checkmark',
        position: 'center',
        scale: 'scale-100',
        opacity: 'opacity-20',
      },
    ],
  },
};

export function getSceneConfig(chapterId) {
  return STORY_SCENES[chapterId] || STORY_SCENES['what-to-expect'];
}
